import { getItemFromLocalStorage, setItemFromLocalStorage } from 'reactApp/appHelpers/localstorageHelpers';

const LOCAL_STORAGE_KEY = 'visit-family-page-or-album-page' as const;

export const getShowFamilyPageOrAlbums = () => getItemFromLocalStorage(LOCAL_STORAGE_KEY);

export const setShowFamilyPageOrAlbums = () => setItemFromLocalStorage(LOCAL_STORAGE_KEY, true);
